var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"tableTitle":_vm.tableTitle,"search-url":_vm.url,"tableType":2,"add":false,"operation-list":_vm.operationList,"operation-left":false,"scale_title":true,"searchTime":true,"deleteUrl":'api/exam/early_del',"page-footer":true},on:{"operation-click":_vm.edit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }